import { t } from 'ember-intl';
import Component from '@glimmer/component';
import LoanDetail from './linked-loans-summary/loan-detail';
import screenIs from 'tio-common/helpers/screen-is';
import type { LoanSummary } from 'tio-common/types/loan-summary';
import type AccountModel from 'tio-data/models/account';
import type PersonModel from 'tio-data/models/person';
import { Section, VStack } from 'tio-reimagined/components/layout';
import Table from 'tio-reimagined/components/table';
import type { ObservableSource } from 'tio-employee/services/observability';

export interface AccountsLinkedLoansSummarySignature {
  Args: {
    accounts: AccountModel[];
    person: PersonModel;
    loanSummary: LoanSummary;
    source: ObservableSource;
  };
}

export default class AccountsLinkedLoansSummary extends Component<AccountsLinkedLoansSummarySignature> {
  <template>
    <VStack>
      {{#if (screenIs "md")}}
        {{#each @accounts as |account|}}
          <Section class="overflow-auto">
            <:header>{{account.institutionName}}</:header>
            <:body>
              <Table>
                <:thead as |options|>
                  <options.tr>
                    <options.th>
                      {{t "pslf_dashboard.actions.dialog.loan_name"}}
                    </options.th>
                    <options.th>
                      {{t "pslf_dashboard.actions.dialog.repayment_plan"}}
                    </options.th>
                    <options.th>
                      {{t "pslf_dashboard.actions.dialog.loan_type"}}
                    </options.th>
                    <options.th>
                      {{t "pslf_dashboard.actions.dialog.interest_rate"}}
                    </options.th>
                    <options.th class="text-right">
                      {{t "pslf_dashboard.actions.dialog.current_balance"}}
                    </options.th>
                    <options.th />
                  </options.tr>
                </:thead>
                <:tbody as |options|>
                  {{#each account.activeLoans as |loan|}}
                    <LoanDetail
                      @style="row"
                      @loan={{loan}}
                      @options={{options}}
                      @source={{@source}}
                    />
                  {{/each}}
                </:tbody>
              </Table>
            </:body>
          </Section>
        {{/each}}
      {{else}}
        {{#each @accounts as |account|}}
          <Section>
            <:header>{{account.institutionName}}</:header>
            <:body>
              <ul>
                {{#each account.activeLoans as |loan|}}
                  <LoanDetail @style="list" @loan={{loan}} @source={{@source}} />
                {{/each}}
              </ul>
            </:body>
          </Section>
        {{/each}}
      {{/if}}
    </VStack>
  </template>
}
